import { render } from "./ResponsibleProducerCreate.vue?vue&type=template&id=43ee6436"
import script from "./ResponsibleProducerCreate.vue?vue&type=script&lang=js"
export * from "./ResponsibleProducerCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__